import { Divider, makeStyles, Theme } from '@material-ui/core';
import React from 'react';

interface ProfileCardHeaderProps {
  children?: React.ReactNode;
  className?: string;
  dataTestId?: string;
}

export default function ProfileCardHeader({ children, className = '', dataTestId }: ProfileCardHeaderProps) {
  const classes = useStyles();
  return (
    <>
      <div className={`${classes.root} ${className}`} data-testid={dataTestId}>
        {children}
      </div>
      <Divider />
    </>
  );
}

const useStyles = makeStyles((_theme: Theme) => ({
  root: {
    padding: '16px 24px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
    flexWrap: 'wrap',
  },
}));
